import React from "react";
import green_tick from '../../../assets/section_new_images/exploremore/green_tick.png'


const SingleLineJob = ({ item, tickMark }) => {
  return (
    <div
      className="text-center px-3 py-2 px-md-4 d-flex align-items-center flex-row what_will_you_learn"
      style={{
        color: item.txtColor ? item.txtColor : "#727272",
        font: "600 clamp(1rem,1.5vw, 1.5rem)/normal Nunito",
        backgroundColor: item.bgColor ? item.bgColor : "#F1F1FF",
        borderRadius: '3rem',
        gap: 'clamp(0.5rem, 1.5vw, 1rem)'
      }}
    >
      {tickMark && <img src={green_tick} alt='tick' />}
      {item.contentTxt}
    </div>
  );
};

export default SingleLineJob;
